import {useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import {fetchPatientDetailsUuid, postPatientReport} from '../Redux/Thunk/Actions';
import '../styles/PatientReportFileTemplateCreate.scss';
import FigmaHeader from './FigmaHeader/FigmaHeader';

// Common styles
const commonStyles = {
  input: {
    border: '1px solid #b0a4a4ff',
    outline: 'none',
    padding: '10px',
    backgroundColor: 'white',
    width: '100%'
  },
  label: {
    fontWeight: 600
  },
  separator: {
    fontWeight: 600,
    fontSize: '18px'
  },
  section: {
    maxWidth: '97%',
    margin: '0 auto'
  }
};

// Section header component
const SectionHeader = ({title, className = 'spermiogram-head'}) => (
  <h2
    style={{
      textAlign: 'center',
      backgroundColor: '#f7f7f7',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      fontSize: '18px',
      fontWeight: '600',
      padding: '5px 0 5px 8px',
      margin: '8px 0'
    }}
    className={className}>
    {title}
  </h2>
);

// Patient Info Section component
const PatientInfoSection = ({patientNumber, partnerType, show, handleChange, valueChange}) => {
  const genderOptions = [
    {value: '', label: 'Select Gender'},
    {value: 'Male', label: 'Male'},
    {value: 'Female', label: 'Female'},
    {value: 'Others', label: 'Others'},
    {value: 'Decline to State', label: 'Decline to State'}
  ];

  return (
    <div className='' style={{width: '100%', display: 'block'}} id={`patientInfo${patientNumber}`}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'center',
          gap: '3px',
          backgroundColor: '#f7f7f7 ',
          borderRadius: '6px',
          padding: '16px 8px 16px 8px',
          gap: '3px'
        }}>
        {/* Patient ID */}
        <FormField label='Patient ID' name={`patientId${patientNumber}`} value={valueChange[`patientId${patientNumber}`]} onChange={handleChange} show={show} width='250px' labelWidth='125px' />

        {/* Patient Name */}
        <FormField
          label={`${partnerType} Partner Name`}
          name={`patientName${patientNumber}`}
          value={valueChange[`patientName${patientNumber}`]}
          onChange={handleChange}
          show={show}
          width='250px'
          labelWidth='125px'
        />

        {/* Gender */}
        <FormField
          label='Gender'
          type='select'
          name={`gender${patientNumber}`}
          value={valueChange[`gender${patientNumber}`]}
          onChange={handleChange}
          show={show}
          options={genderOptions}
          width='250px'
          labelWidth='125px'
        />

        {/* Age */}
        <FormField label='Age' name={`age${patientNumber}`} value={valueChange[`age${patientNumber}`]} onChange={handleChange} show={show} width='250px' labelWidth='125px' />
      </div>
    </div>
  );
};

// Reusable FormField component
const FormField = ({label, type = 'text', name, value, onChange, show, options = [], width = '200px', labelWidth = '160px', reference}) => {
  const inputStyle = {...commonStyles.input, width};

  if (show) {
    // Display mode (read-only)
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: `${labelWidth} 16px 1fr`,
          alignItems: 'center',
          gap: '16px'
        }}>
        <span style={{...commonStyles.label, whiteSpace: 'nowrap', fontSize: '14px'}}>{label}</span>
        <span style={commonStyles.separator}>:</span>
        <span style={{fontSize: '14px', textAlign: 'left'}}>{value}</span>
      </div>
    );
  }

  // Edit mode
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `${labelWidth} 16px ${width}`,
        alignItems: 'center',
        gap: '16px'
      }}>
      <span style={{...commonStyles.label, whiteSpace: 'nowrap', fontSize: '14px'}}>{label}</span>
      <span style={commonStyles.separator}>:</span>

      {type === 'select' ? (
        <select name={name} value={value} onChange={onChange} style={inputStyle}>
          {options.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      ) : (
        <input type={type} name={name} value={value} onChange={onChange} style={inputStyle} />
      )}
    </div>
  );
};

function DIFReport(props) {
  const [show, setshow] = useState(false);
  const Content = useRef();
  const [valueChange, setvalueChange] = useState({
    gender1: 'Male',
    gender2: 'Male',
    bloodGroup1: 'A+',
    bloodGroup2: 'A+',
    coupleId: '',

    // DFI specific fields
    daysAbstinence: '',
    collectionDate: '',
    collectionTime: '',
    collectionTimeHour: '',
    collectionTimeMinute: '',
    collectionTimePeriod: 'AM',
    examinationTime: '',
    examinationTimeHour: '',
    examinationTimeMinute: '',
    examinationTimePeriod: 'AM',
    reportingDate: '',

    // Semen analysis fields
    spermConcentration: '',
    totalSpermNumber: '',
    progressiveMotility: '',
    totalMotility: '',
    vitality: '',
    normalMorphology: '',

    // Macroscopic analysis
    volume: '',
    pH: '',
    appearance: '',
    colour: '',
    homogeneity: '',
    completeSample: '',
    liquefactionTime: '',

    // Microscopic analysis
    agglutination: '',
    leucocytes: '',

    // DFI Analysis
    totalSpermatozoaAnalyzed: '',
    nonFragmentedHalos: '',
    fragmentedHalos: '',
    observedDFI: '',
    dfiCategory: '',

    // Diagnosis
    diagnosis: '',

    // Reported by
    reportedBy: ''
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [patientOne_UUId, setPatientOne_UUId] = useState('');
  const [patientTwo_UUId, setPatientTwo_UUId] = useState('');

  const handleChange = e => {
    const text = e.target.value;

    if (e.target.name === 'patientId1' || e.target.name === 'patientId2') {
      if (text.length === 10 && text.charAt(0) === 'A') {
        const fetchData = async () => {
          const payload = {p_uhid: text};
          props.loaderchange('true');
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const isSinglePatient = response.payload.data.data.length === 1;
            if (isSinglePatient) {
              const data = response.payload.data.data[0];
              const namePat1 = data?.titles + ' ' + data?.first_name + ' ' + data?.last_name;

              if (e.target.name === 'patientId1') {
                setPatientOne_UUId(data?.id);
                setvalueChange({
                  ...valueChange,
                  patientName1: namePat1,
                  age1: data?.age,
                  gender1: data?.gender,
                  patientId1: text
                });
              } else {
                setPatientTwo_UUId(data?.id);
                setvalueChange({
                  ...valueChange,
                  patientName2: namePat1,
                  age2: data?.age,
                  gender2: data?.gender,
                  patientId2: text
                });
              }
            } else {
              const data = response.payload.data.data[0].gender === 'Male' ? response.payload.data.data[0] : response.payload.data.data[1];
              const data2 = response.payload.data.data[1].gender === 'Female' ? response.payload.data.data[1] : response.payload.data.data[0];
              const namePat1 = data?.titles + ' ' + data?.first_name + ' ' + data?.last_name;
              const namePat2 = data2?.titles + ' ' + data2?.first_name + ' ' + data2?.last_name;

              setPatientOne_UUId(data?.id);
              setPatientTwo_UUId(data2?.id);
              setvalueChange({
                ...valueChange,
                patientName1: namePat1,
                patientName2: namePat2,
                age1: data?.age,
                age2: data2?.age,
                gender1: data?.gender,
                gender2: data2?.gender,
                patientId1: data?.p_uhid,
                patientId2: data2?.p_uhid
              });
            }
            props.loaderchange('false');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        };
        fetchData();
      } else {
        setvalueChange({
          ...valueChange,
          [e.target.name]: text
        });
      }
    } else {
      setvalueChange({...valueChange, [e.target.name]: text});
    }
  };

  const handletest = async () => {
    try {
      if (
        valueChange.patientOne_UUId !== '' &&
        valueChange.patientId1 !== '' &&
        valueChange.patientId1.length === 10 &&
        (valueChange.patientId2 !== '' ? valueChange.patientId1 !== valueChange.patientId2 : true)
      ) {
        setshow(true);
        setTimeout(async () => {
          const htmlPayload = document.getElementById('reportcreate').innerHTML;
          const payload = {
            report_template: htmlPayload,
            patient_id: patientOne_UUId,
            description: '',
            patient_two: patientTwo_UUId,
            couple_id: valueChange.coupleId,
            template_type: 'DFI Report'
          };

          props.loaderchange(true);
          const reportResponse = await dispatch(postPatientReport({type: '2', payload: payload}));

          if (reportResponse?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/patientreports');
            Swal.fire({
              title: 'Successful.',
              text: 'Report added successful.',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
            });
          } else {
            setshow(false);
            props.loaderchange(false);
            props.popupalert(true);
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert(false);
            }, 2000);
          }
        }, 3000);
      } else {
        Swal.fire({
          title: 'Error.',
          text: 'Please enter valid patient id.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  const sideactive = useSelector(state => state.counter.sidebarnav);

  return (
    <>
      <div className={sideactive ? 'maincontainer-patient-sa' : 'maincontainer-patient'}>
        <div className='row'>
          <div className='col'>
            <h3 className='page-title'>Report Template</h3>
            <ul className='breadcrumb'>
              <li className='breadcrumb-item'>
                <a href='/' style={{textDecoration: 'none', color: 'black'}}>
                  Dashboard /
                </a>
                <a href='/patientreports' style={{textDecoration: 'none', color: 'black'}}>
                  &nbsp;Patient Reports
                </a>
              </li>
              <li className='breadcrumb-item active'>Report Template</li>
            </ul>
          </div>
        </div>
        <h1>🧬 DNA FRAGMENTATION INDEX (DFI) REPORT - SCD METHOD</h1>
        <div style={{backgroundColor: 'white', maxWidth: '100%'}} className='patientreport' id='reportcreate'>
          {/* Patient Information Header */}
          <FigmaHeader />

          {/* Patient & Couple Details */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              gap: '3px',
              border: '1px solid #000',
              marginBottom: '10px'
            }}
            className='report-template-wrap1'>
            <PatientInfoSection patientNumber={1} partnerType='Male' show={show} handleChange={handleChange} valueChange={valueChange} />
            <div className='patientreportcreate2' style={{width: '100%', height: '100%', backgroundColor: '#f7f7f7'}} id='patientInfo2'>
              <PatientInfoSection patientNumber={2} partnerType='Female' show={show} handleChange={handleChange} valueChange={valueChange} />
            </div>
          </div>
          <h2 style={{textAlign: 'center', fontWeight: '600', backgroundColor: '#f7f7f7', padding: '10px'}}>SEMEN ANALYSIS & DNA FRAGMENTATION REPORT – SCD METHOD</h2>

          {/* <SectionHeader title='🔬 SEMEN ANALYSIS & DNA FRAGMENTATION REPORT – SCD METHOD' /> */}
          {/* Report Content */}
          <div style={{padding: '10px'}}>
            {/* Basic Information */}
            <div style={{marginBottom: '10px'}}>
              <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px'}}>
                <div style={{display: 'flex', flexDirection: 'column', gap: '16px'}}>
                  <FormField label='Days of Abstinence:' type='text' name='daysAbstinence' value={valueChange.daysAbstinence} onChange={handleChange} show={show} width='200px' labelWidth='160px' />
                  {!show ? (
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: '160px 16px 120px 60px 60px',
                        alignItems: 'center',
                        gap: '8px'
                      }}>
                      <span style={{...commonStyles.label, whiteSpace: 'nowrap', fontSize: '14px'}}>Time of Collection:</span>
                      <span style={commonStyles.separator}>:</span>
                      <div style={{display: 'flex', alignItems: 'center', gap: '10px', paddingLeft: '15px'}}>
                        <input
                          type='number'
                          min='1'
                          max='12'
                          placeholder='hh'
                          name='collectionTimeHour'
                          value={valueChange.collectionTimeHour || ''}
                          onChange={handleChange}
                          style={{...commonStyles.input, width: '50px', textAlign: 'center'}}
                        />
                        <span>:</span>
                        <input
                          type='number'
                          min='0'
                          max='59'
                          placeholder='mm'
                          name='collectionTimeMinute'
                          value={valueChange.collectionTimeMinute || ''}
                          onChange={handleChange}
                          style={{...commonStyles.input, width: '50px', textAlign: 'center'}}
                        />
                        <select name='collectionTimePeriod' value={valueChange.collectionTimePeriod || ''} onChange={handleChange} style={{...commonStyles.input, width: '50px'}}>
                          <option value='AM'>AM</option>
                          <option value='PM'>PM</option>
                        </select>
                      </div>
                    </div>
                  ) : (
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: '160px 16px 1fr',
                        alignItems: 'center',
                        gap: '16px'
                      }}>
                      <span style={{...commonStyles.label, whiteSpace: 'nowrap', fontSize: '14px'}}>Time of Collection:</span>
                      <span style={commonStyles.separator}>:</span>
                      <span style={{fontSize: '14px', textAlign: 'left'}}>
                        {valueChange.collectionTimeHour && valueChange.collectionTimeMinute && valueChange.collectionTimePeriod
                          ? `${valueChange.collectionTimeHour}:${valueChange.collectionTimeMinute.toString().padStart(2, '0')} ${valueChange.collectionTimePeriod}`
                          : ''}
                      </span>
                    </div>
                  )}
                  <FormField label='Date of Reporting:' type='date' name='reportingDate' value={valueChange.reportingDate} onChange={handleChange} show={show} width='200px' labelWidth='160px' />
                </div>

                <div style={{display: 'flex', flexDirection: 'column', gap: '16px'}}>
                  <FormField label='Date of Collection:' type='date' name='collectionDate' value={valueChange.collectionDate} onChange={handleChange} show={show} width='200px' labelWidth='160px' />
                  {!show ? (
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: '160px 16px 120px 60px 60px',
                        alignItems: 'center',
                        gap: '8px'
                      }}>
                      <span style={{...commonStyles.label, whiteSpace: 'nowrap', fontSize: '14px'}}>Time of Examination:</span>
                      <span style={commonStyles.separator}>:</span>
                      <div style={{display: 'flex', alignItems: 'center', gap: '10px', paddingLeft: '15px'}}>
                        <input
                          type='number'
                          min='1'
                          max='12'
                          placeholder='hh'
                          name='examinationTimeHour'
                          value={valueChange.examinationTimeHour || ''}
                          onChange={handleChange}
                          style={{...commonStyles.input, width: '50px', textAlign: 'center'}}
                        />
                        <span>:</span>
                        <input
                          type='number'
                          min='0'
                          max='59'
                          placeholder='mm'
                          name='examinationTimeMinute'
                          value={valueChange.examinationTimeMinute || ''}
                          onChange={handleChange}
                          style={{...commonStyles.input, width: '50px', textAlign: 'center'}}
                        />
                        <select name='examinationTimePeriod' value={valueChange.examinationTimePeriod || ''} onChange={handleChange} style={{...commonStyles.input, width: '50px'}}>
                          <option value='AM'>AM</option>
                          <option value='PM'>PM</option>
                        </select>
                      </div>
                    </div>
                  ) : (
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: '160px 16px 1fr',
                        alignItems: 'center',
                        gap: '16px'
                      }}>
                      <span style={{...commonStyles.label, whiteSpace: 'nowrap', fontSize: '14px'}}>Time of Examination:</span>
                      <span style={commonStyles.separator}>:</span>
                      <span style={{fontSize: '14px', textAlign: 'left'}}>
                        {valueChange.examinationTimeHour && valueChange.examinationTimeMinute && valueChange.examinationTimePeriod
                          ? `${valueChange.examinationTimeHour}:${valueChange.examinationTimeMinute.toString().padStart(2, '0')} ${valueChange.examinationTimePeriod}`
                          : ''}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Semen Analysis Table */}
            {/* <div style={{marginBottom: '20px'}}>
              <table style={{width: '100%', borderCollapse: 'collapse', border: '1px solid #ddd'}}>
                <thead>
                  <tr style={{backgroundColor: '#f0f0f0'}}>
                    <th style={{padding: '8px', border: '1px solid #ddd', textAlign: 'left'}}>Parameter</th>
                    <th style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>Patient Value</th>
                    <th style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>WHO Reference</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{padding: '8px', border: '1px solid #ddd', fontWeight: 600}}>Sperm Concentration (million/mL)</td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>
                      <input
                        type='text'
                        className={`createTime ${show ? 'hide' : 'show'}`}
                        name='spermConcentration'
                        value={valueChange.spermConcentration || ''}
                        onChange={e => handleChange(e)}
                        style={{...commonStyles.input, width: '150px'}}
                      />
                      <span className={`input ${!show ? 'hide' : 'show'}`}>{valueChange.spermConcentration}</span>
                    </td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>≥ 16</td>
                  </tr>
                  <tr>
                    <td style={{padding: '8px', border: '1px solid #ddd', fontWeight: 600}}>Total Sperm Number (million/ejaculate)</td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>
                      <input
                        type='text'
                        className={`createTime ${show ? 'hide' : 'show'}`}
                        name='totalSpermNumber'
                        value={valueChange.totalSpermNumber || ''}
                        onChange={e => handleChange(e)}
                        style={{...commonStyles.input, width: '150px'}}
                      />
                      <span className={`input ${!show ? 'hide' : 'show'}`}>{valueChange.totalSpermNumber}</span>
                    </td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>≥ 39</td>
                  </tr>
                  <tr>
                    <td style={{padding: '8px', border: '1px solid #ddd', fontWeight: 600}}>Progressive Motility (%)</td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>
                      <input
                        type='text'
                        className={`createTime ${show ? 'hide' : 'show'}`}
                        name='progressiveMotility'
                        value={valueChange.progressiveMotility || ''}
                        onChange={e => handleChange(e)}
                        style={{...commonStyles.input, width: '150px'}}
                      />
                      <span className={`input ${!show ? 'hide' : 'show'}`}>{valueChange.progressiveMotility}</span>
                    </td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>≥ 30</td>
                  </tr>
                  <tr>
                    <td style={{padding: '8px', border: '1px solid #ddd', fontWeight: 600}}>Total Motility (%)</td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>
                      <input
                        type='text'
                        className={`createTime ${show ? 'hide' : 'show'}`}
                        name='totalMotility'
                        value={valueChange.totalMotility || ''}
                        onChange={e => handleChange(e)}
                        style={{...commonStyles.input, width: '150px'}}
                      />
                      <span className={`input ${!show ? 'hide' : 'show'}`}>{valueChange.totalMotility}</span>
                    </td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>≥ 42</td>
                  </tr>
                  <tr>
                    <td style={{padding: '8px', border: '1px solid #ddd', fontWeight: 600}}>Vitality (%)</td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>
                      <input
                        type='text'
                        className={`createTime ${show ? 'hide' : 'show'}`}
                        name='vitality'
                        value={valueChange.vitality || ''}
                        onChange={e => handleChange(e)}
                        style={{...commonStyles.input, width: '150px'}}
                      />
                      <span className={`input ${!show ? 'hide' : 'show'}`}>{valueChange.vitality}</span>
                    </td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>≥ 54</td>
                  </tr>
                  <tr>
                    <td style={{padding: '8px', border: '1px solid #ddd', fontWeight: 600}}>Normal Morphology (%)</td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>
                      <input
                        type='text'
                        className={`createTime ${show ? 'hide' : 'show'}`}
                        name='normalMorphology'
                        value={valueChange.normalMorphology || ''}
                        onChange={e => handleChange(e)}
                        style={{...commonStyles.input, width: '150px'}}
                      />
                      <span className={`input ${!show ? 'hide' : 'show'}`}>{valueChange.normalMorphology}</span>
                    </td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>≥ 4</td>
                  </tr>
                </tbody>
              </table>
            </div> */}

            {/* Macroscopic Analysis */}
            <div style={{marginBottom: '10px'}}>
              <SectionHeader title='⚗️ MACROSCOPIC ANALYSIS (WHO 6th Edition)' />
              <table style={{width: '100%', borderCollapse: 'collapse', border: '1px solid #ddd'}}>
                <thead>
                  <tr style={{backgroundColor: '#f0f0f0'}}>
                    <th style={{padding: '4px', border: '1px solid #ddd', textAlign: 'left'}}>Parameter</th>
                    <th style={{padding: '4px', border: '1px solid #ddd', textAlign: 'center'}}>Patient Value</th>
                    <th style={{padding: '4px', border: '1px solid #ddd', textAlign: 'center'}}>WHO Reference</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{padding: '4px', border: '1px solid #ddd', fontWeight: 600}}>Volume (mL)</td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>
                      <input
                        type='text'
                        className={`createTime ${show ? 'hide' : 'show'}`}
                        name='volume'
                        value={valueChange.volume || ''}
                        onChange={e => handleChange(e)}
                        style={{...commonStyles.input, width: '150px'}}
                      />
                      <span className={`input ${!show ? 'hide' : 'show'}`}>{valueChange.volume}</span>
                    </td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>≥ 1.4 mL</td>
                  </tr>
                  <tr>
                    <td style={{padding: '8px', border: '1px solid #ddd', fontWeight: 600}}>pH</td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>
                      <input
                        type='text'
                        className={`createTime ${show ? 'hide' : 'show'}`}
                        name='pH'
                        value={valueChange.pH || ''}
                        onChange={e => handleChange(e)}
                        style={{...commonStyles.input, width: '150px'}}
                      />
                      <span className={`input ${!show ? 'hide' : 'show'}`}>{valueChange.pH}</span>
                    </td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>≥ 7.2</td>
                  </tr>
                  <tr>
                    <td style={{padding: '8px', border: '1px solid #ddd', fontWeight: 600}}>Appearance</td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>
                      <input
                        type='text'
                        className={`createTime ${show ? 'hide' : 'show'}`}
                        name='appearance'
                        value={valueChange.appearance || ''}
                        onChange={e => handleChange(e)}
                        style={{...commonStyles.input, width: '150px'}}
                      />
                      <span className={`input ${!show ? 'hide' : 'show'}`}>{valueChange.appearance}</span>
                    </td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>Opalescent, grey-white</td>
                  </tr>
                  <tr>
                    <td style={{padding: '8px', border: '1px solid #ddd', fontWeight: 600}}>Colour</td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>
                      <input
                        type='text'
                        className={`createTime ${show ? 'hide' : 'show'}`}
                        name='colour'
                        value={valueChange.colour || ''}
                        onChange={e => handleChange(e)}
                        style={{...commonStyles.input, width: '150px'}}
                      />
                      <span className={`input ${!show ? 'hide' : 'show'}`}>{valueChange.colour}</span>
                    </td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>Whitish-grey</td>
                  </tr>
                  <tr>
                    <td style={{padding: '8px', border: '1px solid #ddd', fontWeight: 600}}>Homogeneity</td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>
                      <input
                        type='text'
                        className={`createTime ${show ? 'hide' : 'show'}`}
                        name='homogeneity'
                        value={valueChange.homogeneity || ''}
                        onChange={e => handleChange(e)}
                        style={{...commonStyles.input, width: '150px'}}
                      />
                      <span className={`input ${!show ? 'hide' : 'show'}`}>{valueChange.homogeneity}</span>
                    </td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>Homogenous</td>
                  </tr>
                  <tr>
                    <td style={{padding: '8px', border: '1px solid #ddd', fontWeight: 600}}>Complete Sample</td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>
                      <input
                        type='text'
                        className={`createTime ${show ? 'hide' : 'show'}`}
                        name='completeSample'
                        value={valueChange.completeSample || ''}
                        onChange={e => handleChange(e)}
                        style={{...commonStyles.input, width: '150px'}}
                      />
                      <span className={`input ${!show ? 'hide' : 'show'}`}>{valueChange.completeSample}</span>
                    </td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>Yes / No</td>
                  </tr>
                  <tr>
                    <td style={{padding: '8px', border: '1px solid #ddd', fontWeight: 600}}>Liquefaction Time (min)</td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>
                      <input
                        type='text'
                        className={`createTime ${show ? 'hide' : 'show'}`}
                        name='liquefactionTime'
                        value={valueChange.liquefactionTime || ''}
                        onChange={e => handleChange(e)}
                        style={{...commonStyles.input, width: '150px'}}
                      />
                      <span className={`input ${!show ? 'hide' : 'show'}`}>{valueChange.liquefactionTime}</span>
                    </td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>≤ 60 min</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Microscopic Analysis */}
            <div style={{marginBottom: '10px'}}>
              <SectionHeader title='🔬 MICROSCOPIC ANALYSIS (WHO 6th Edition)' />
              <table style={{width: '100%', borderCollapse: 'collapse', border: '1px solid #ddd'}}>
                <thead>
                  <tr style={{backgroundColor: '#f0f0f0'}}>
                    <th style={{padding: '8px', border: '1px solid #ddd', textAlign: 'left'}}>Parameter</th>
                    <th style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>Patient Value</th>
                    <th style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>WHO Reference</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{padding: '8px', border: '1px solid #ddd', fontWeight: 600}}>Agglutination</td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>
                      <input
                        type='text'
                        className={`createTime ${show ? 'hide' : 'show'}`}
                        name='agglutination'
                        value={valueChange.agglutination || ''}
                        onChange={e => handleChange(e)}
                        style={{...commonStyles.input, width: '150px'}}
                      />
                      <span className={`input ${!show ? 'hide' : 'show'}`}>{valueChange.agglutination}</span>
                    </td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>Absent</td>
                  </tr>
                  <tr>
                    <td style={{padding: '8px', border: '1px solid #ddd', fontWeight: 600}}>Sperm Concentration (million/mL)</td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>
                      <input
                        type='text'
                        className={`createTime ${show ? 'hide' : 'show'}`}
                        name='spermConcentration'
                        value={valueChange.spermConcentration || ''}
                        onChange={e => handleChange(e)}
                        style={{...commonStyles.input, width: '150px'}}
                      />
                      <span className={`input ${!show ? 'hide' : 'show'}`}>{valueChange.spermConcentration}</span>
                    </td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>≥ 16</td>
                  </tr>
                  <tr>
                    <td style={{padding: '8px', border: '1px solid #ddd', fontWeight: 600}}>Total Sperm Number (million/ejaculate)</td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>
                      <input
                        type='text'
                        className={`createTime ${show ? 'hide' : 'show'}`}
                        name='totalSpermNumber'
                        value={valueChange.totalSpermNumber || ''}
                        onChange={e => handleChange(e)}
                        style={{...commonStyles.input, width: '150px'}}
                      />
                      <span className={`input ${!show ? 'hide' : 'show'}`}>{valueChange.totalSpermNumber}</span>
                    </td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>≥ 39</td>
                  </tr>
                  <tr>
                    <td style={{padding: '8px', border: '1px solid #ddd', fontWeight: 600}}>Progressive Motility (%)</td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>
                      <input
                        type='text'
                        className={`createTime ${show ? 'hide' : 'show'}`}
                        name='progressiveMotility'
                        value={valueChange.progressiveMotility || ''}
                        onChange={e => handleChange(e)}
                        style={{...commonStyles.input, width: '150px'}}
                      />
                      <span className={`input ${!show ? 'hide' : 'show'}`}>{valueChange.progressiveMotility}</span>
                    </td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>≥ 30</td>
                  </tr>
                  <tr>
                    <td style={{padding: '8px', border: '1px solid #ddd', fontWeight: 600}}>Total Motility (%)</td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>
                      <input
                        type='text'
                        className={`createTime ${show ? 'hide' : 'show'}`}
                        name='totalMotility'
                        value={valueChange.totalMotility || ''}
                        onChange={e => handleChange(e)}
                        style={{...commonStyles.input, width: '150px'}}
                      />
                      <span className={`input ${!show ? 'hide' : 'show'}`}>{valueChange.totalMotility}</span>
                    </td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>≥ 42</td>
                  </tr>
                  <tr>
                    <td style={{padding: '8px', border: '1px solid #ddd', fontWeight: 600}}>Vitality (%)</td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>
                      <input
                        type='text'
                        className={`createTime ${show ? 'hide' : 'show'}`}
                        name='vitality'
                        value={valueChange.vitality || ''}
                        onChange={e => handleChange(e)}
                        style={{...commonStyles.input, width: '150px'}}
                      />
                      <span className={`input ${!show ? 'hide' : 'show'}`}>{valueChange.vitality}</span>
                    </td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>≥ 54</td>
                  </tr>
                  <tr>
                    <td style={{padding: '8px', border: '1px solid #ddd', fontWeight: 600}}>Normal Morphology (%)</td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>
                      <input
                        type='text'
                        className={`createTime ${show ? 'hide' : 'show'}`}
                        name='normalMorphology'
                        value={valueChange.normalMorphology || ''}
                        onChange={e => handleChange(e)}
                        style={{...commonStyles.input, width: '150px'}}
                      />
                      <span className={`input ${!show ? 'hide' : 'show'}`}>{valueChange.normalMorphology}</span>
                    </td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>≥ 4</td>
                  </tr>
                  <tr>
                    <td style={{padding: '8px', border: '1px solid #ddd', fontWeight: 600}}>Round cells/WBCs</td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>
                      <input
                        type='text'
                        className={`createTime ${show ? 'hide' : 'show'}`}
                        name='roundCells'
                        value={valueChange.roundCells || ''}
                        onChange={e => handleChange(e)}
                        style={{...commonStyles.input, width: '150px'}}
                      />
                      <span className={`input ${!show ? 'hide' : 'show'}`}>{valueChange.roundCells}</span>
                    </td>
                    <td style={{padding: '8px', border: '1px solid #ddd', textAlign: 'center'}}>{`<1`}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* DNA Fragmentation Index */}
            <div style={{marginBottom: '10px'}}>
              <SectionHeader title='🧬 DNA FRAGMENTATION INDEX (DFI – SCD METHOD)' />
              <div style={{padding: '10px'}}>
                <div style={{marginBottom: '16px'}}>
                  <div style={{display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '10px'}}>
                    <span style={{fontWeight: 600, width: '340px', display: 'inline-block'}}>Total spermatozoa analyzed:</span>
                    <input
                      type='text'
                      className={`createTime ${show ? 'hide' : 'show'}`}
                      name='totalSpermatozoaAnalyzed'
                      value={valueChange.totalSpermatozoaAnalyzed || ''}
                      onChange={e => handleChange(e)}
                      style={{...commonStyles.input, width: '120px'}}
                    />
                    <span className={`input ${!show ? 'hide' : 'show'}`}>{valueChange.totalSpermatozoaAnalyzed}</span>
                    <span>200 to 300</span>
                  </div>

                  <div style={{display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '10px'}}>
                    <span style={{fontWeight: 600, width: '340px', display: 'inline-block'}}>Large/medium halos (non-fragmented):</span>
                    <input
                      type='text'
                      className={`createTime ${show ? 'hide' : 'show'}`}
                      name='nonFragmentedHalos'
                      value={valueChange.nonFragmentedHalos || ''}
                      onChange={e => handleChange(e)}
                      style={{...commonStyles.input, width: '120px'}}
                    />
                    <span className={`input ${!show ? 'hide' : 'show'}`}>{valueChange.nonFragmentedHalos}</span>
                    <span>%</span>
                  </div>

                  <div style={{display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '10px'}}>
                    <span style={{fontWeight: 600, width: '340px', display: 'inline-block'}}>Small/absent halos (fragmented):</span>
                    <input
                      type='text'
                      className={`createTime ${show ? 'hide' : 'show'}`}
                      name='fragmentedHalos'
                      value={valueChange.fragmentedHalos || ''}
                      onChange={e => handleChange(e)}
                      style={{...commonStyles.input, width: '120px'}}
                    />
                    <span className={`input ${!show ? 'hide' : 'show'}`}>{valueChange.fragmentedHalos}</span>
                    <span>%</span>
                  </div>

                  <div style={{display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '10px'}}>
                    <span style={{fontWeight: 600, width: '340px', display: 'inline-block'}}>Observed DFI:</span>
                    <input
                      type='text'
                      className={`createTime ${show ? 'hide' : 'show'}`}
                      name='observedDFI'
                      value={valueChange.observedDFI || ''}
                      onChange={e => handleChange(e)}
                      style={{...commonStyles.input, width: '120px'}}
                    />
                    <span className={`input ${!show ? 'hide' : 'show'}`}>{valueChange.observedDFI}</span>
                    <span>%</span>
                  </div>

                  <div style={{marginTop: '15px', padding: '10px', backgroundColor: '#fff3cd', border: '1px solid #ffeaa7'}}>
                    <div style={{display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'wrap'}}>
                      <span style={{fontWeight: 600}}>Reference Ranges:</span>
                      <span>• &lt; 15&rarr; Normal</span>
                      <span>• 15&ndash;30 &rarr; Moderate </span>
                      <span>• &gt; 30 &rarr; High</span>
                    </div>
                  </div>

                  <div style={{display: 'flex', alignItems: 'center', gap: '16px', marginTop: '10px'}}>
                    <span style={{fontWeight: 600, width: '340px', display: 'inline-block'}}>Category:</span>
                    <select
                      className={`createTime ${show ? 'hide' : 'show'}`}
                      name='dfiCategory'
                      value={valueChange.dfiCategory || ''}
                      onChange={e => handleChange(e)}
                      style={{...commonStyles.input, width: '120px'}}>
                      <option value=''>Select</option>
                      <option value='Normal'>Normal</option>
                      <option value='Borderline'>Borderline</option>
                      <option value='High'>High</option>
                    </select>
                    <span className={`input ${!show ? 'hide' : 'show'}`}>{valueChange.dfiCategory}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Signature Section */}
            <div style={{marginTop: '20px', textAlign: 'right'}}>
              <div style={{display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'flex-end'}}>
                <span style={{fontWeight: 600}}>Reported by:</span>
                {!show ? (
                  <input type='text' name='reportedBy' value={valueChange.reportedBy} onChange={handleChange} style={{minWidth: '200px', maxWidth: '400px', border: '1px solid #000'}} />
                ) : (
                  <span style={{borderBottom: '1px solid #000', minWidth: '200px', maxWidth: '400px', textAlign: 'left'}}>{valueChange.reportedBy}</span>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className='Footer'>
          <button onClick={handletest} className='Button_Create'>
            Add Report
          </button>
        </div>
      </div>
    </>
  );
}

export default DIFReport;
